export const THEME_PHASES = {
  green: {
    accent: '#00ff41',
    accentLight: '#4dff73',
    accentDark: '#00cc34',
    accentGlow: 'rgba(0, 255, 65, 0.4)',
    accentRgb: '0, 255, 65',
    matrixBright: 'rgba(0, 255, 65, 0.95)',
    matrixMid: 'rgba(255, 255, 255, 0.8)',
    h1: 125,
    s1: 100,
    l1: 50,
  },
  purple: {
    accent: '#d94cdb',
    accentLight: '#e87aed',
    accentDark: '#b83bb8',
    accentGlow: 'rgba(217, 76, 219, 0.4)',
    accentRgb: '217, 76, 219',
    matrixBright: 'rgba(217, 76, 219, 0.95)',
    matrixMid: 'rgba(255, 255, 255, 0.8)',
    h1: 299,
    s1: 67,
    l1: 58,
  },
};

export const applyThemePhase = (phase) => {
  const theme = THEME_PHASES[phase];
  if (!theme) return;

  const root = document.documentElement;
  root.dataset.accentPhase = phase;
  root.style.setProperty('--accent', theme.accent);
  root.style.setProperty('--accent-light', theme.accentLight);
  root.style.setProperty('--accent-dark', theme.accentDark);
  root.style.setProperty('--accent-glow', theme.accentGlow);
  root.style.setProperty('--accent-rgb', theme.accentRgb);
  root.style.setProperty('--primary', theme.accent);
  root.style.setProperty('--primary-light', theme.accentLight);
  root.style.setProperty('--primary-dark', theme.accentDark);

  window.__FTMX_THEME__ = {
    h1: theme.h1,
    s1: theme.s1,
    l1: theme.l1,
    phase,
  };

  const themeMeta = document.querySelector('meta[name="theme-color"]');
  if (themeMeta) {
    themeMeta.setAttribute('content', theme.accent);
  }
};
